import { IInternalApplications } from '@api/models';
import { Dropdown, DropdownItem, DropdownList, DropdownTrigger } from '@library/dropdown';
import { GalleryCard } from 'modules/shared/features/content';
import { toast } from 'react-toastify';

interface ImageDownloaderProps {
    data: IInternalApplications;
}

const InternalApplicationCard = (props: ImageDownloaderProps) => {
    const { data } = props;

    const copyToClipboard = (url: string) => {
        navigator.clipboard.writeText(url);
        toast.success('Link Copied');
    };

    const handleDownload = (url: string) => {
        const link = document.createElement('a');
        link.href = url;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success('Downloading');
    };

    return (
        <div className="relative">
            <GalleryCard>
                <div className="p-2">
                    <img
                        className="max-h-10 max-w-[140px] mt-4"
                        src="/internal-applications/image-downloader.svg"
                        alt=""
                    />
                    <div className="font-bold mt-4">{data.name}</div>
                    <p className="mt-4 text-sm">{data.description}</p>
                    <div className="flex justify-end space-x-2 mt-4">
                        <Dropdown placement="bottom-end">
                            <DropdownTrigger>
                                <div
                                    className={`relative inline-flex items-center text-xs px-2 py-1 rounded-full font-semibold bg-gray-800 text-white cursor-pointer`}
                                >
                                    <>
                                        Download
                                        <img className="ml-2" src="/icons/apple.svg" alt="" width={15} height={15} />
                                    </>
                                </div>
                            </DropdownTrigger>

                            <DropdownList className="min-w-[100px]">
                                <DropdownItem
                                    // onClick={() => copyToClipboard(import.meta.env.VITE_APP_IMAGE_DOWNLOADER_MAC_URL)}
                                    onClick={() => copyToClipboard(data.macUrl)}
                                >
                                    Copy Link
                                </DropdownItem>
                                <DropdownItem
                                    // onClick={() => handleDownload(import.meta.env.VITE_APP_IMAGE_DOWNLOADER_MAC_URL)}
                                    onClick={() => handleDownload(data.macUrl)}
                                >
                                    Download
                                </DropdownItem>
                            </DropdownList>
                        </Dropdown>

                        <Dropdown placement="bottom-end">
                            <DropdownTrigger>
                                <div
                                    className={`relative inline-flex items-center text-xs px-2 py-1 rounded-full font-semibold bg-blue-500 text-white cursor-pointer`}
                                >
                                    <>
                                        Download
                                        <img className="ml-2" src="/icons/windows.svg" alt="" />
                                    </>
                                </div>
                            </DropdownTrigger>

                            <DropdownList className="min-w-[100px]">
                                <DropdownItem
                                    // onClick={() =>
                                    //     copyToClipboard(import.meta.env.VITE_APP_IMAGE_DOWNLOADER_WINDOWS_URL)
                                    // }
                                    onClick={() => copyToClipboard(data.windowsUrl)}
                                >
                                    Copy Link
                                </DropdownItem>
                                <DropdownItem
                                    // onClick={() =>
                                    //     handleDownload(import.meta.env.VITE_APP_IMAGE_DOWNLOADER_WINDOWS_URL)
                                    // }
                                    onClick={() => handleDownload(data.windowsUrl)}
                                >
                                    Download
                                </DropdownItem>
                            </DropdownList>
                        </Dropdown>
                    </div>
                </div>
            </GalleryCard>
        </div>
    );
};

export default InternalApplicationCard;
